import { useQuery } from '@tanstack/react-query';
import { SubscriptionService } from '../services/SubscriptionService';
import { useActiveOrgId } from '@/shared/contexts/SuperAdminOrgContext';
import { Subscription } from '../types/subscription-types';

interface UseSubscriptionReturn {
  subscription: Subscription | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useSubscription = (): UseSubscriptionReturn => {
  const activeOrgId = useActiveOrgId();

  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    // Sem a organização na chave, trocar de organização continuava exibindo a
    // assinatura da anterior — o backend responde certo, o cache é que não vira
    // (AB#84509). É o que mantinha o card de créditos de um plano que não é por
    // créditos.
    queryKey: ['subscription', 'my', activeOrgId],
    queryFn: async () => {
      const response = await SubscriptionService.getMySubscription();
      return response.data;
    },
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutos
  });

  return {
    subscription: data,
    isLoading,
    isError,
    error: error as Error | null,
    refetch,
  };
};
